import _ from 'lodash';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Controller} from 'react-hook-form';
import { Form } from 'react-bootstrap';
import ErrorMesssage from 'v2/common/components/ErrorMessage/index';
import { onRegexOnlyNumber } from 'common/stringUtils/toPositiveNumberString';

const propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  onUpdatePipeConfig: PropTypes.func.isRequired,
  pipeConfig: PropTypes.shape({})
};

const defaultProps = {
  pipeConfig: {},
};

const NumberFormField = ({
  name: propsName, value, control, errors, onUpdatePipeConfig, pipeConfig
}) => {
  const uniqueId = useMemo(() => _.uniqueId(`pipe_${propsName}_`), [propsName]);
  const errorMessage = _.get(errors, `${uniqueId}.message`, '');
  const isDayCandleInterval = _.get(pipeConfig, 'config.candleInterval', '') === '1 days'

  const rulesValidator = useMemo(() => ({
    validate: (val) => {
      if (Number(val) === 0) return 'Please enter the valid value';
      if (isDayCandleInterval && Number(val) > 20) {
        return 'Candle cannot be greater than 20 days';
      }
      return null;
    }
  }), [isDayCandleInterval]);

  return (
    <ErrorMesssage message={errorMessage}>
      <Controller
        render={({ onChange, ref, name }) => (
          <Form.Control
            type="number"
            id={name}
            size="sm"
            name={uniqueId}
            ref={ref}
            value={value?.toString() || ''}
            onChange={(event) => {
              onUpdatePipeConfig(propsName, (onRegexOnlyNumber(event.target.value) || 0));
              onChange(event.target.value);
            }}
          />
        )}
        control={control}
        defaultValue={value}
        name={uniqueId}
        rules={rulesValidator}
      />
    </ErrorMesssage>
  );
};

NumberFormField.propTypes = propTypes;
NumberFormField.defaultProps = defaultProps;

export default NumberFormField;
